// extracted by mini-css-extract-plugin
export default {"securitytab":"Bottom_securitytab__NC7uq","p":"Bottom_p__DPD8I","h3":"Bottom_h3__Mhy+6","securitytab1":"Bottom_securitytab1__JdzLj","securityprivacy":"Bottom_securityprivacy__TYrIF"};